import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  InputLabelComponent,
  CalendarInputComponent,
} from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreConsumptionsFormEvents,
  OffshoreConsumptionsFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-inert-gas-systems',
  templateUrl: './inert-gas-systems.component.html',
  styleUrl: './inert-gas-systems.component.css',
  imports: [FormsModule, InputLabelComponent, CalendarInputComponent],
})
export class InertGasSystemsComponent extends AbstractStoreConnectedSectionComponent {
  object = Object;
  tabId = 'consumptions';
  sectionId = 'inertGasSystems';
  events = injectDispatch(offshoreConsumptionsFormEvents);
  consumptionsStore = inject(OffshoreConsumptionsFormStore);
}
